<template>
    <div>
        <div v-if="!loading">
            <create-query
                :operands="columns"
                :column-definitions="columnsDef"
                :search-elements="rows.map(r => r.codeItems)"
                @query-filter="addQuery"
                @regex-filter="addRegex" />

            <div class="filters">
                <b-taglist v-if="queries.length > 0 || regex.length >0">
                    <b-tag
                        v-for="q in queriesDisplay"
                        :key="q"
                        type="is-light"
                        size="is-medium"
                        closable
                        @close="removeQuery(q)">
                        {{ q }}
                    </b-tag>
                    <b-tag
                        v-for="r in regex"
                        :key="r"
                        type="is-light"
                        size="is-medium"
                        closable
                        @close="removeRegex(r)">
                        {{ r }}
                    </b-tag>
                </b-taglist>
            </div>
        </div>
    </div>
</template>

<script>
    import CreateQuery from './CreateQuery.vue';
    import { useCodeQueryStore } from '@/stores/codeQueryStore';

    export default {
        components: {
            CreateQuery
        },
        props: {
            rows: {
                type: Array,
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            },
            columnsDef: {
                type: Array,
                required: true
            }
        },
        emits: [
            'queries'
        ],
        data() {
            return {
                codeQueryStore: useCodeQueryStore()
            };
        },
        url: {
            queriesParam: {
                param: 'queries',
                noHistory: true
            },
            regexParam: {
                param: 'regex',
                noHistory: true
            }
        },
        computed: {
            queriesDisplay() {
                return this.queries.map(q => q.join(' '));
            },
            queries() {
                return this.codeQueryStore.queries;
            },
            regex() {
                return this.codeQueryStore.regexs;
            },
            filters() {
                return this.codeQueryStore.filters;
            },
            queriesParam: {
                get() {
                    return this.codeQueryStore.queries;
                },
                set(value) {
                    this.codeQueryStore.addQueries(value);
                }
            },
            regexParam: {
                get() {
                    return this.codeQueryStore.regexs;
                },
                set(value) {
                    this.codeQueryStore.addRegexs(value);
                }
            },
            columns() {
                return this.codeQueryStore.columns;
            },
            libraryName() {
                return this.codeQueryStore.libraryName;
            }
        },
        watch: {
            regex() {
                this.regexParam = this.regex;
            },
            libraryName() {
                if (this.libraryName.length === 0) return;
                const filtersLocalStorageKey = `Library.${this.libraryName}.filters`;
                if (this.regexParam && this.regexParam.length > 0 || this.queriesParam && this.queriesParam.length > 0) {
                    const urlFilters = { 'queries': this.queriesParam, 'regEx': this.regexParam };
                    localStorage.setItem(filtersLocalStorageKey, JSON.stringify(urlFilters));
                }
                const persistedFilters = JSON.parse(localStorage.getItem(filtersLocalStorageKey));
                if (persistedFilters) {
                    if (persistedFilters.queries.length) {
                        this.codeQueryStore.addQueries(persistedFilters.queries);
                    }

                    if (persistedFilters.regEx.length) {
                        this.codeQueryStore.addRegexs(persistedFilters.regEx);
                    }
                } else {
                    const defaultQuery = ['isValid', '=', 'true'];
                    this.codeQueryStore.addQuery(defaultQuery);
                }
            }
        },
        unmounted() {
            this.codeQueryStore.reset();
        },
        mounted() {
            this.$watch('filters', this.filterWatcher);
        },
        methods: {
            addQuery(queryFrags) {
                this.codeQueryStore.addQuery(queryFrags);
            },
            removeQuery(query) {
                const matches = query.match(/^(\w+)\s+(like|=|!=|<|>|is(?:\s*not)?)\s+(.*)$/);
                /*
                 * ^ start of string
                 * (\w+) any word (captured in output)
                 * \s+ any whitespace
                 * (like|=|!=|<|>|is(?:\s*not)?) either like, =, !=, <, >, is or is not (captured in output)
                 * \s+ any whitespace
                 * (.*)$ rest of string (captured in output)
                 */
                matches.shift(); // discard first group which is the entire matched string

                this.codeQueryStore.removeQuery(matches);
            },
            addRegex(regex) {
                this.codeQueryStore.addRegex(regex);
            },
            removeRegex(r) {
                this.codeQueryStore.removeRegex(r);
            },
            filterWatcher() {
                if (this.libraryName.length === 0) return;
                const filters = {
                    queries: this.queries,
                    regEx: this.regex
                };
                localStorage.setItem(`Library.${this.libraryName}.filters`, JSON.stringify(filters));
                this.$emit('queries', filters);
            }
        }
    };
</script>
